module.exports = __webpack_public_path__ + "img/icon_home_swipeItem_channelExclusive.24c37a8e.png";